// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb3bdcde","455":"806f260c","977":"ab38357f"}[chunkId] + ".chunk.js";
};